import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconFusion = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={21}
    fill="none"
    viewBox="0 0 18 21"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.95}
      d="M.25 19.336c.195-1.68 1.21-6.016 6.25-9.297C1.46 6.72.445 2.383.25.703.21.352.484.04.875.04h1.25a.569.569 0 0 1 .625.508c.04.195.078.43.117.742h12.227c.039-.273.078-.547.117-.742.039-.313.312-.508.625-.508h1.25c.39 0 .664.313.625.664-.195 1.875-1.445 7.11-8.164 10.43-1.25.625-2.266 1.289-3.086 2.031h5c-.234-.195-.43-.39-.664-.586.82-.43 1.601-.898 2.265-1.367 3.672 3.125 4.493 6.64 4.649 8.125.039.352-.234.664-.625.664l-1.25.04c-.313 0-.586-.274-.625-.548-.04-.195-.078-.469-.156-.703H2.867c-.039.273-.078.508-.117.703a.632.632 0 0 1-.625.547L.875 20c-.39 0-.703-.313-.625-.664ZM8.96 8.594a11.536 11.536 0 0 0 2.54-1.719H6.46c.704.625 1.524 1.172 2.5 1.719Zm5.157-4.844H3.844c.195.39.469.82.82 1.25h8.633c.312-.39.586-.82.82-1.25ZM3.883 16.25h10.195a8.597 8.597 0 0 0-.82-1.25H4.664c-.312.39-.586.82-.781 1.25Z"
    />
  </svg>
));
export default SvgIconFusion;
